import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "./ResumeManagement.css";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import LoadingWithProgress from "../../components/LoadingWithProgress/LoadingWithProgress";
import Modal from "../../components/Modal/Modal";

const API_URL = process.env.REACT_APP_API_URL;

const ResumeManagement = () => {
	const { id } = useParams();
	const numericId = parseInt(id, 10);
	const [openDeleteModal, setOpenDeleteModal] = useState(false);
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [currentPage, setCurrentPage] = useState(
		Number(localStorage.getItem("cur-r-page")) || 1
	);
	const [data, setData] = useState([]);
	const [displayedResumes, setDisplayedResumes] = useState([]);
	const [searchData, setSearchData] = useState({
		title: localStorage.getItem("r-title") || "",
		type: localStorage.getItem("r-type") || "",
		language: localStorage.getItem("r-language") || "",
	});
	const [loading, setLoading] = useState(false);
	const [loadingProgress, setLoadingProgress] = useState(false);
	const [isComplete, setIsComplete] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const profName = location.state?.name;
	const role = localStorage.getItem("role");
	const [modalData, setModalData] = useState({
		isVisible: false,
		message: "",
		type: "",
	});

	const handleAnimationComplete = () => {
		setLoadingProgress(false);
		setTimeout(() => window.location.reload(), 300);
	};

	const typeOfResume = {
		1: "دروس ارائه شده",
		2: "كتب تاليفی، ترجمه، ويرایش، چاپ مجدد",
		3: "پروژه‌های كارشناسی",
		4: "پایان‌نامه‌های تحصیلات تكمیلی",
		5: "مقالات ملی و بین المللی",
		6: "مقالات ارائه‌شده در همایش‌ها",
		7: "طرح‌های پژوهشی",
		8: "جوایز و افتخارات",
		9: "عضویت در مجامع ملی و بین‌المللی",
		10: "اختراعات",
		11: "فعاليت‌های اجرایی",
	};

	const resumeList = [
		"--------",
		"دروس ارائه شده",
		"كتب تاليفی، ترجمه، ويرایش، چاپ مجدد",
		"پروژه‌های كارشناسی",
		"پایان‌نامه‌های تحصیلات تكمیلی",
		"مقالات ملی و بین المللی",
		"مقالات ارائه‌شده در همایش‌ها",
		"طرح‌های پژوهشی",
		"جوایز و افتخارات",
		"عضویت در مجامع ملی و بین‌المللی",
		"اختراعات",
		"فعاليت‌های اجرایی",
	];

	const languages = [
		{ name: "فارسی", value: "فارسی", id: "persian" },
		{ name: "انگلیسی", value: "انگلیسی", id: "english" },
		{ name: "هر دو", value: "", id: "both" },
	];

	const maxPageButtons = 5;
	const pageSize = 5;

	useEffect(() => {
		localStorage.setItem("r-type", searchData.type);
		localStorage.setItem("r-title", searchData.title);
		localStorage.setItem("r-language", searchData.language);
	}, [searchData]);

	useEffect(() => {
		const handleBeforeUnload = (event) => {
			if (loading) {
				event.preventDefault();
				event.returnValue = "";
			}
		};

		window.addEventListener("beforeunload", handleBeforeUnload);
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [loading]);

	useEffect(() => {
		const handleKeyDown = (event) => {
			if (
				loading &&
				(event.key === "F5" || (event.ctrlKey && event.key === "r"))
			) {
				event.preventDefault();
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
		};
	}, [loading]);

	useEffect(() => {
		if (profName) {
			localStorage.setItem("prof_name", profName);
		}
		const fetchData = async () => {
			try {
				const token = localStorage.getItem("token");
				const response = await axios.get(
					`${API_URL}/resume-management/resume?&title=${
						searchData.title
					}&type=${searchData.type}&lan=${searchData.language}${
						role === "admin" ? `&id=${numericId}` : ""
					}`,
					{
						method: "GET",
						headers: {
							Authorization: `Token ${token}`,
							"Content-Type": "application/json",
						},
					}
				);
				setData(response.data);
				let endIndex = pageSize * currentPage;
				let startIndex = endIndex - pageSize;
				let resumeList = response.data.slice(startIndex, endIndex);
				setDisplayedResumes(resumeList);
			} catch (error) {
				setModalData({
					isVisible: true,
					message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
					type: "error",
				});
			}
		};
		fetchData();

		const handleBeforeUnload = () => {
			localStorage.removeItem("r-type");
			localStorage.removeItem("r-title");
			localStorage.removeItem("r-language");
			localStorage.removeItem("cur-r-page");
		};
		window.addEventListener("beforeunload", handleBeforeUnload);
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);

	useEffect(() => {
		const filterData = async () => {
			const token = localStorage.getItem("token");
			try {
				const response = await axios.get(
					`${API_URL}/resume-management/resume?&title=${
						searchData.title
					}&type=${searchData.type}&lan=${searchData.language}${
						role === "admin" ? `&id=${numericId}` : ""
					}`,
					{
						method: "GET",
						headers: {
							Authorization: `Token ${token}`,
							"Content-Type": "application/json",
						},
					}
				);
				setData(response.data);
				const totalPages = Math.ceil(response.data.length / pageSize);
				if (currentPage > totalPages) {
					setCurrentPage(totalPages > 0 ? totalPages : 1);
				}
				let endIndex = pageSize * currentPage;
				let startIndex = endIndex - pageSize;
				let resumeList = response.data.slice(startIndex, endIndex);
				setDisplayedResumes(resumeList);
			} catch (error) {
				setModalData({
					isVisible: true,
					message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
					type: "error",
				});
			}
		};
		filterData();
	}, [searchData]);

	useEffect(() => {
		localStorage.setItem("cur-r-page", currentPage);
		let endIndex = pageSize * currentPage;
		let startIndex = endIndex - pageSize;
		let resumeList = data.slice(startIndex, endIndex);
		setDisplayedResumes(resumeList);
	}, [currentPage]);

	const totalPages = Math.ceil(data.length / pageSize);

	const getPaginationButtons = () => {
		const buttons = [];
		const startPage = Math.max(
			1,
			currentPage - Math.floor(maxPageButtons / 2)
		);
		const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

		for (let i = startPage; i <= endPage; i++) {
			buttons.push(
				<button
					className={`pagination-btn ${
						i === currentPage ? "active" : ""
					}`}
					onClick={() => setCurrentPage(i)}
				>
					{i}
				</button>
			);
		}
		return buttons;
	};

	const handleButtonClickShow = async (id) => {
		role === "admin"
			? navigate("/admin/user-management/activities/resume/" + id, {
					state: { userId: numericId },
			  })
			: navigate("/user/activities/resume/" + id);
	};

	const handleNavigateAddActivity = async () => {
		role === "admin"
			? navigate(
					"/admin/user-management/activities/add-activity/" +
						numericId
			  )
			: navigate("/user/activities/add-activity");
	};

	const handleChange = (event) => {
		setCurrentPage(1);
		setSearchData({
			...searchData,
			[event.target.name]: event.target.value,
		});
	};

	const handleDeleteActivity = async () => {
		const token = localStorage.getItem("token");

		if (role === "user") {
			try {
				const response = await fetch(
					`${API_URL}/resume-management/activity/` + selectedRowId,
					{
						method: "DELETE",
						headers: {
							Authorization: `Token ${token}`,
							"Content-Type": "application/json",
						},
					}
				);
				if (response.ok) {
					setModalData({
						isVisible: true,
						message: "فعالیت با موفقیت حذف شد",
						type: "success",
					});
				} else {
					const errorData = await response.json();
					setModalData({
						isVisible: true,
						message: errorData.error,
						type: "error",
					});
				}
			} catch (error) {
				setModalData({
					isVisible: true,
					message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
					type: "error",
				});
			} finally {
				setOpenDeleteModal(false);
				const timer = setTimeout(() => {
					window.location.reload();
				}, 2000);
				return () => clearTimeout(timer);
			}
		} else if (role === "admin") {
			try {
				const response = await fetch(
					`${API_URL}/resume-management/activity/` + selectedRowId,
					{
						method: "DELETE",
						headers: {
							Authorization: `Token ${token}`,
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ id: numericId }),
					}
				);
				if (response.ok) {
					setModalData({
						isVisible: true,
						message: "فعالیت با موفقیت حذف شد",
						type: "success",
					});
				} else {
					const errorData = await response.json();
					setModalData({
						isVisible: true,
						message: errorData.error,
						type: "error",
					});
				}
			} catch (error) {
				setModalData({
					isVisible: true,
					message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
					type: "error",
				});
			} finally {
				setOpenDeleteModal(false);
				const timer = setTimeout(() => {
					window.location.reload();
				}, 2000);
				return () => clearTimeout(timer);
			}
		}
	};

	const handleUpdateResume = async () => {
		const token = localStorage.getItem("token");
		setLoadingProgress(true);

		if (role === "user") {
			try {
				const response = await fetch(
					`${API_URL}/resume-management/golestan-resume`,
					{
						method: "POST",
						headers: {
							Authorization: `Token ${token}`,
							"Content-Type": "application/json",
						},
					}
				);
				setIsComplete(true);

				if (response.ok) {
					setModalData({
						isVisible: true,
						message: "رزومه با موفقیت بروزرسانی شد",
						type: "success",
					});
				} else {
					const errorData = await response.json();
					setModalData({
						isVisible: true,
						message: errorData.error,
						type: "error",
					});
				}
			} catch (error) {
				setIsComplete(true);
				setModalData({
					isVisible: true,
					message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
					type: "error",
				});
			} finally {
			}
		} else if (role === "admin") {
			try {
				const response = await fetch(
					`${API_URL}/resume-management/golestan-resume`,
					{
						method: "POST",
						headers: {
							Authorization: `Token ${token}`,
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ user_id: numericId }),
					}
				);
				setIsComplete(true);

				if (response.ok) {
					setModalData({
						isVisible: true,
						message: "رزومه با موفقیت بروزرسانی شد",
						type: "success",
					});
				} else {
					const errorData = await response.json();
					setModalData({
						isVisible: true,
						message: errorData.error,
						type: "error",
					});
				}
			} catch (error) {
				setIsComplete(true);
				setModalData({
					isVisible: true,
					message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
					type: "error",
				});
			} finally {
			}
		}
	};

	return (
		<div className="professors-list-container container">
			{loadingProgress && (
				<LoadingWithProgress isComplete={isComplete} onComplete={handleAnimationComplete} />
			)}
			{loading && <Loading />}
			<div className="professors-card">
				<header className="card-header">
					{role === "admin" ? (
						<h1 className="header-title">
							فهرست فعالیت های{" "}
							<span className="prof-name">{localStorage.getItem("prof_name")}</span>
						</h1>
					) : (
						<h1 className="header-title">فهرست فعالیت ها</h1>
					)}
				</header>
				<div className="search-container">
					<div className="filter-header-container">
						<div className="search-group">
							<label htmlFor="type">نوع</label>
							<select
								name="type"
								id="type"
								type="search"
								value={searchData.type}
								onChange={handleChange}
							>
								{resumeList.map((resume, index) =>
									index !== 0 ? (
										<option
											className="light-text"
											value={index}
										>
											{resume}
										</option>
									) : (
										<option
											className="light-text"
											value={""}
										>
											{resume}
										</option>
									)
								)}
							</select>
						</div>
						<div className="search-group">
							<label htmlFor="title">عنوان</label>
							<input
								id="title"
								name="title"
								type="search"
								placeholder=""
								value={searchData.title}
								onChange={handleChange}
							/>
						</div>
						<div className="search-group last-child">
							{languages.map((language) => (
								<div className="language-radio">
									<input
										type="radio"
										id={language.id}
										name="language"
										value={language.value}
										checked={
											searchData.language ===
											language.value
										}
										onChange={handleChange}
									/>
									<label for={language.id}>
										{language.name}
									</label>
								</div>
							))}
						</div>
						<div className="filter-button-container">
							<button
								className="update-profile-button btn medium-text update-resume"
								onClick={handleUpdateResume}
							>
								بروزرسانی رزومه
							</button>
							<button
								className="btn medium-text add-activity"
								onClick={handleNavigateAddActivity}
							>
								اضافه کردن فعالیت
							</button>
						</div>
					</div>
				</div>
				<div className="card-body table-container">
					<table className="professors-table">
						<thead>
							<tr>
								<th className="type-container">نوع</th>
								<th className="title-container">عنوان</th>
								<th className="publish-container">
									وضعیت انتشار
								</th>
								<th className="action-container">عملیات</th>
							</tr>
						</thead>
						<tbody>
							{displayedResumes.length > 0 ? (
								displayedResumes.map((resume) => (
									<tr key={resume.id}>
										<td>
											{
												typeOfResume[
													resume.type_of_activity
												]
											}
										</td>
										<td>{resume.title}</td>
										<td>
											{resume.is_publish === true
												? "قابل انتشار"
												: "عدم انتشار"}
										</td>
										<td className="action-container">
											<div className="actions">
												<button
													className="action-button delete medium-text"
													onClick={() => {
														setSelectedRowId(
															resume.id
														);
														setOpenDeleteModal(
															true
														);
													}}
												>
													حذف
												</button>
												<button
													className="action-button update resume medium-text"
													onClick={() =>
														handleButtonClickShow(
															resume.id
														)
													}
												>
													مشاهده و تغییر
												</button>
											</div>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={4} className="no-data">
										داده مورد نظر در دسترس نیست
									</td>
								</tr>
							)}
						</tbody>
					</table>
					<div className="pagination-container">
						<button
							className="pagination-btn medium-text"
							disabled={currentPage === 1}
							onClick={() => setCurrentPage(currentPage - 1)}
						>
							قبلی
						</button>
						{getPaginationButtons()}
						<button
							className="pagination-btn medium-text"
							disabled={currentPage === totalPages}
							onClick={() => setCurrentPage(currentPage + 1)}
						>
							بعدی
						</button>
					</div>
				</div>
			</div>
			<Modal
				message={modalData.message}
				type={modalData.type}
				isVisible={modalData.isVisible}
				onClose={() => setModalData({ ...modalData, isVisible: false })}
			/>
			{openDeleteModal && (
				<div className="dialog-overlay">
					<div className="dialog">
						<h2 className="dialog-title">تایید حذف فعالیت</h2>
						<p className="dialog-content">
							آیا از حذف کردن فعالیت اطمینان دارید؟
						</p>
						<div className="dialog-actions">
							<button
								className="dialog-button cancel medium-text"
								onClick={() => setOpenDeleteModal(false)}
							>
								خیر
							</button>
							<button
								className="dialog-button confirm medium-text"
								onClick={handleDeleteActivity}
							>
								بله
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default ResumeManagement;
